import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
  FormControl,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";
import { Box } from "react-bootstrap-icons";
import moment from "moment";
import { dateFormat } from "../../../utils/Date";
import ComponentLoader from "../../../ComponentLoader";

function ArE4Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);
  // InstituteId,RptMonth,IAMRSId,InvestigatorId,FieldVisitDate,Particulars,Solutions,Numberofbeneficiaries
  const [investigatorName,setInvestigatorName] = useState("")
  const [fieldVisitDate, setFieldVisitDate] = useState("");
  const [particulars, setParticulars] = useState("");
  const [solutions, setSolutions] = useState("");
  const [numberofbeneficiaries, setNumberofbeneficiaries] = useState("");
  const [loader,setLoader] =useState(true);
  const [investigatorNameErr,setInvestigatorNameErr] = useState(false)
  const [fieldVisitDateErr, setFieldVisitDateErr] = useState(false);
  const [particularsErr, setParticularsErr] = useState(false);
  const [solutionsErr, setSolutionsErr] = useState(false);
  const [numberofbeneficiariesErr, setNumberofbeneficiariesErr] = useState(false);

  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [inves, setInves] = useState([]);
  const [insti, setInsti] = useState([]);

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    // resolver: yupResolver(C4VALI),
  });

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
     
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head("Farm Advisory");
  }, []);

  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const tok = localStorage.getItem("token");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const institute = localStorage.getItem("loginId");
    setInsti(institute);
    handleInvestigators(tok,institute);
  }, []);

  const backs = () => {
    navigate("/ArE4");
  };

  const edit = (item) => {
    console.log(item);
    setInvestigatorName(item.investigatorId);
    setFieldVisitDate(dateFormat(item.fieldVisitDate));
    setParticulars(item.particulars);
    setSolutions(item.solutions);
    setNumberofbeneficiaries(item.numberofbeneficiaries);
    setId(item.id);
  };

  // Investigator
  const handleInvestigators = async (token,id) => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(`${window.BASE}${window.INVESTIGATORIDMAPNAME}${id}`, {
        headers: h,
      });
      console.log(data);
      setInves(data);setLoader(false);
    } catch (error) {
      console.log(error);setLoader(false);
    }
  };

  const handleLeavepage = async (data) => {
    console.log(data);
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const d = {
      id,
      InvestigatorId: investigatorName,
      FieldVisitDate: fieldVisitDate,
      Particulars: particulars,
      Numberofbeneficiaries: numberofbeneficiaries,
      Solutions: solutions,
      IAMRSId: state.id,
      InstituteId: parseInt(insti),
      RptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(`${window.BASE}${window.Er4SAVE}`, d, {
          headers: h,
        });
        console.log(data);
        setStudentbtn(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/ArE4");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          alert(data.errorMsgs[0])
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(`${window.BASE}${window.Er4EDIT}`, d, {
          headers: h,
        });
        console.log(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/ArE4");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
 
  const formValidateFun = () => {
    if (!investigatorName) {
      setInvestigatorNameErr(true);
      document.getElementById("investigatorName").focus();
    } else if (!fieldVisitDate) {
      setFieldVisitDateErr(true);
      document.getElementById("fieldVisitDate").focus();
    } else if (!particulars) {
      setParticularsErr(true);
      document.getElementById("particulars").focus();
    } else if (!solutions) {
      setSolutionsErr(true);
      document.getElementById("solutions").focus();
    } else if (!numberofbeneficiaries) {
      setNumberofbeneficiariesErr(true);
      document.getElementById("numberofbeneficiaries").focus();
    } else {
      handleLeavepage();
    }
  };

  return (
    <div className="main-container-margin">
         <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/GeneralAR">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>E4. Diagnostic Field Visit and Farm Advisory made</span>
        </div>
      </div>

      {/* <form className="from-mains" onSubmit={handleSubmit(handleLeavepage)}> */}
        <div className="form-control">
          <h5 style={{ margin: 20 }}>
          E4. Diagnostic Field Visit and Farm Advisory made
          </h5>

          <FormControl
            style={{ width: "48%", margin: 12 }}
            error={investigatorNameErr}
            id="investigatorName"
          >
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Name of the faculty
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="investigatorName"
              value={investigatorName}
              label="Programme Type"
              size="small"
              sx={{ width: "100%" }}
              onChange={(e) => {
                setInvestigatorName(e.target.value);
                setInvestigatorNameErr(false);
              }}
            >
              {inves?.map((row, index) => {
                return (
                  <MenuItem key={row.index} value={row.id}>
                    {row.investigatorName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <TextField
            error={fieldVisitDateErr}
            id="fieldVisitDate"
            label="Field Visit Date"
            variant="outlined"
            type="date"
            style={{ margin: "10px", width: "48%" }}
            value={fieldVisitDate}
            onChange={(e) => {
              setFieldVisitDate(e.target.value);
              setFieldVisitDateErr(false);
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              placeholder: "",
            }}
          />

          <TextField
            error={particularsErr}
            id="particulars"
            label="Particulars (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={particulars}
            onChange={(e) => {
              setParticulars(e.target.value);
              setParticularsErr(false);
            }}
          />

          <TextField
            error={solutionsErr}
            id="solutions"
            label="Number of Beneficiaries (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={solutions}
            onChange={(e) => {
              setSolutions(e.target.value);
              setSolutionsErr(false);
            }}
          />

          <TextField
            error={numberofbeneficiariesErr}
            id="numberofbeneficiaries"
            label="Solutions offered (Max 50 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={numberofbeneficiaries}
            onChange={(e) => {
              setNumberofbeneficiaries(e.target.value);
              setNumberofbeneficiariesErr(false);
            }}
          />

          <div className="from-last">
            <button
              type="submit"
              style={{ backgroundColor: "#008CBA",padding:"5px",borderRadius:"3px",width:"80px",color:"#fff" }}
              onClick={backs}
            >
              Back
            </button>
            <button style={{paddingTop:"5px"}} type="submit" className="sbmit-buttons" onClick={formValidateFun}>
            Save
            </button>
          </div>
        </div>
      {/* </form> */}
    </div>
  );
}

export default ArE4Inside;
